<template>
  <v-card>
      <v-card-title>
        <span class="headline">Are you sure change loan amount from Not Qualified to ${{amount}}?</span>
      </v-card-title>
      <v-card-text class="content">
        <ValidationObserver ref="observer" v-slot="{ validate, reset }">
          <ValidationProvider name="Notes" rules="required" v-slot="{ errors }">
            <v-textarea
              v-model="notes"
              label="Notes"
              hide-details="auto"
              :error-messages="errors[0]"
            ></v-textarea>
          </ValidationProvider>
        </ValidationObserver>
      </v-card-text>
      <v-card-actions class="footer">
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="save">OK</v-btn>
        <v-btn color="primary" text @click="hideDialog">Cancel</v-btn>
      </v-card-actions>
  </v-card>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { OriginationBusinessApi } from '@/api/pandaria'
import { DataType, Popup } from '@/util/index'
const popup = new Popup()

export default {
  name: 'special-consideration-customer-dialog',
  components: {
    ValidationProvider,
    ValidationObserver
  },
  props: {
    loan: Object
  },
  data () {
    return {
      notes: '',
      amount: 200
    }
  },
  computed: {
    loanId () {
      return this.loan.id
    }
  },
  watch: {
    loanId: {
      handler: function () {
        if (this.loan.loanType === DataType.LoanTypeEnum.MULTIPLE_ADVANCE_LOAN.value) {
          this.amount = 400
        }
      },
      immediate: true
    }
  },
  methods: {
    hideDialog () {
      this.$emit('hideDialog')
    },
    save () {
      const $this = this
      $this.$refs.observer.validate().then(result => {
        if (result) {
          const requestData = {
            loanId: $this.loanId,
            notes: $this.notes
          }
          OriginationBusinessApi.specialLoanAmount(requestData, function (result) {
            $this.$eventBus.$emit('loanIntegratedComputationResult', result)
          }, function (result) {
            popup.popupForWarning(result.message)
          })
          $this.$emit('hideDialog')
        }
      })
    }
  }
}
</script>
